const moment = require('moment');

export const decimalSeparator = Intl.NumberFormat(navigator.languages[0] || 'pl')
    ?.formatToParts(1.1)
    ?.find(part => part.type === 'decimal')
    ?.value || ',';


export const thousandSeparator = (11111).toLocaleString()
    .replace(/1/g, '');

export default {
    methods: {
        formatToIsoDate(date) {
            return this.$moment(date, 'L').isValid() ? this.$moment(date, 'L').format('YYYY-MM-DD')
                : this.$moment(date).format('YYYY-MM-DD');
        },
        parseDate(dateString) {
            if (this.isDate(dateString)) {
                return moment(dateString).toDate();
            }
        },
        parseFilterDate(dateString) {
            if (this.isDate(dateString)) {
                return moment(dateString, "YYYY-MM-DD").toDate();
            }
        },
        isDate(dateString) {
            return moment(dateString, 'L', true).isValid() || moment(dateString).isValid();
        },
        getParsedLocaleNumberOrInputString(numberString) {
            return this.thousand(numberString.toString().replace(new RegExp('\\' + thousandSeparator, 'g'), ''));
        },
        thousand(numberString) {
            return numberString.replace(
                /^\d+/,
                number => [...number].map(
                    (digit, index, digits) => (
                        !index || (digits.length - index) % 3 ? '' : thousandSeparator
                    ) + digit
                ).join(''));
        },
        formatLocaleNumber(number) {
            if (number === undefined || number === null) {
                return '';
            }
            return this.thousand(number.toLocaleString()
                .replace(new RegExp('\\\s', 'g'), '')
                .replace(new RegExp('\\' + decimalSeparator), '.') || '');
        },
        setValue(value, setterPath) {
            _.set(this, setterPath, value);
        },
        removeThousandSeparator(value) {
            return value.toString().replace(new RegExp('\\' + thousandSeparator, 'g'), '');
        }
    }
}
